import { render, staticRenderFns } from "./popupInvitation.vue?vue&type=template&id=93feb066&scoped=true&"
import script from "./popupInvitation.vue?vue&type=script&lang=js&"
export * from "./popupInvitation.vue?vue&type=script&lang=js&"
import style0 from "./popupInvitation.vue?vue&type=style&index=0&id=93feb066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93feb066",
  null
  
)

export default component.exports